import styled from 'styled-components'

export const Footer = styled.div`
  align-items: center;
  background-color: #151515;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px 80px;
`

export const SocialMedia = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  width: 240px;
`
